import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, purpleMui, rydeColors } from "@ryde/theme";

export const RideEditableDropdownBoundTemplateStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "ride-editable-dropdown-bound-popover-container",
  },
)`
  .edit-icon {
    font-size: 16px;
  }

  .phone_forwarded_icon {
    display: flex;
  }

  .phone_forwarded_icon svg {
    margin-inline-end: 8px;
    font-size: 16px;
    color: ${rydeColors.steel};
    cursor: pointer;
  }
`;

export const RideEditableDropdownPopoverContainer = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "ride-editable-dropdown-bound-popover-container",
  },
)`
  width: 150px;
  height: calc(200px + 38px);
  overflow: hidden;

  .react-select__menu {
    margin-top: 0;
    margin-bottom: 0;
  }

  .react-select__menu-list {
    height: 200px;
    overflow-y: scroll;
  }

  .react-select__option:hover,
  .react-select__option--focused {
    color: ${rydeColors.purpleTitle};
    background-color: ${rydeColors.viewOptionHover};
  }

  .react-select__control--focused,
  .react-select__control--focused:hover {
    border-color: ${purpleMui._500};
  }
`;

export const RideEditableDropdownPopoverFooter = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "ride-editable-dropdown-bound-popover-footer",
  },
)`
  border-top: 1px solid ${greyMui._400};

  .clear-button {
    display: flex;
    align-items: center;
    width: 100%;
    height: 38px;
    padding: 10px;
    border: none;
    background: transparent;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: ${greyMui._100};
    }
  }

  .clear-text {
    margin-inline-start: 5px;
  }

  .clear-icon {
    color: ${rydeColors.red};
  }
`;
